export function dateMD(timestamp) {
  var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
  // var Y = date.getFullYear() + '-';
  var M =
    (date.getMonth() + 1 < 10
      ? "0" + (date.getMonth() + 1)
      : date.getMonth() + 1) + "-";
  var D = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
  // var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
  // var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
  // var s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
  return M + D;
}

export function dateMDHM(timestamp) {
  var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
  var M =
    (date.getMonth() + 1 < 10
      ? "0" + (date.getMonth() + 1)
      : date.getMonth() + 1) + "月";
  var D =
    (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + "日  ";
  var h =
    (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
  var m =
    (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) + "";
  return M + D + h + m;
}

export function dateYMD(timestamp) {
  var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
  var Y = date.getFullYear() + "年";
  var M =
    (date.getMonth() + 1 < 10
      ? "0" + (date.getMonth() + 1)
      : date.getMonth() + 1) + "月";
  var D =
    (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + "日  ";
  return Y + M + D;
}

export function timeDiffHoursText(startDate) {
  var endDate = Date.parse(new Date());
  var calDiffs = endDate / 1000 - startDate;
  var hours = parseInt(calDiffs / 3600);

  if (hours < 24) {
    return 23 - hours;
  } else {
    return -1;
  }
}

export function timeDiffMinuteText(startDate) {
  var endDate = Date.parse(new Date());
  var calDiffs = endDate / 1000 - startDate;
  var hours = calDiffs / 3600;
  if (hours >= 1) {
    calDiffs = calDiffs - hours * 3600;
    var sec = calDiffs / 60;
    if (sec < 60) {
      return 60 - sec;
    } else {
      return 0;
    }
  } else {
    var sec2 = parseInt(calDiffs / 60);
    if (sec2 < 60) {
      return 60 - sec2;
    } else {
      return 0;
    }
  }
}

export function phoneHideFormat(str) {
  return str.substr(0, 3) + "****" + str.substr(7);
}

//处理成时分
export function dateHM(timestamp) {
  var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不乘1000
  // var Y = date.getFullYear() + '-';
  // var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMont()+1) + '-';
  // var D = (date.getDate() < 10 ? '0'+date.getDate() : date.getDate()) + ' ';
  var h =
    (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
  var m = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
  // var s = (date.getSeconds() < 10 ? '0'+date.getSeconds() : date.getSecond());
  return h + m;
}

// 将2023-10-16 21:32:51格式的数据转换成 10月16日21:32格式
export function dateChangeFomat(date) {
  var arr = date.split(" ");
  var arr1 = arr[0].split("-");
  var arr2 = arr[1].split(":");
  return arr1[1] + "月" + arr1[2] + "日 " + arr2[0] + ":" + arr2[1];

  // let dateStr=new Date(date)
  // let month = dateStr.getMonth()+1
  // let day = dateStr.getDate()
  // let hour = dateStr.getHours()
  // let minute = dateStr.getMinutes()
  // let lastTime=`${month}月${day}日 ${hour}:${minute}`
  // console.log(lastTime)
  // return lastTime
}

// 处理成年月日时分
export function dateYMDHM(timestamp) {
  var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
  var Y = date.getFullYear() + "年";
  var M =
    (date.getMonth() + 1 < 10
      ? "0" + (date.getMonth() + 1)
      : date.getMonth() + 1) + "月";
  var D =
    (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + "日  ";
  var h =
    (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
  var m =
    (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) + "";
  return Y + M + D + h + m;
}

// 时间处理函数   将2023-12-06 20:19:27格式的时间转换为距离当前时间的时间差
export function timeDifference(timeStr) {
  const now = new Date();
  const givenTime = new Date(timeStr);
  const differenceInMilliseconds = now - givenTime;
  const differenceInSeconds = Math.floor(differenceInMilliseconds / 1000);
  const differenceInMinutes = Math.floor(differenceInSeconds / 60);
  const differenceInHours = Math.floor(differenceInMinutes / 60);
  const differenceInDays = Math.floor(differenceInHours / 24);

  if (differenceInDays >= 1) {
    return `${differenceInDays}天前`;
  } else if (differenceInHours >= 1) {
    return `${differenceInHours}小时前`;
  } else if (differenceInMinutes >= 1) {
    return `${differenceInMinutes}分钟前`;
  } else {
    return `刚刚`;
  }
}

// 将时间戳转换为2024-01-12 19:30格式
export function timestampToTime(timestamp) {
  var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000

  var Y = date.getFullYear() + "-";
  var M =
    (date.getMonth() + 1 < 10
      ? "0" + (date.getMonth() + 1)
      : date.getMonth() + 1) + "-";
  var D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate() + "";
  var h =
    (+date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
  var m =
    (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) + "";
  return Y + M + D + "  " + h + m;
}
// 隐藏手机号
export function hidePhone(phone) {
  if (phone) {
    let phoneStr = phone.toString();
    let phoneLength = phoneStr.length;
    let phoneHide =
      phoneStr.substring(0, 3) +
      "****" +
      phoneStr.substring(phoneLength - 4, phoneLength);
    return phoneHide;
  } else return phone;
}

// 将2023-10-16 21:32:51格式的数据转换成 2023-10-16格式
export function dateChangeFomat2(date) {
  var arr = date.split(" ");
  var arr1 = arr[0].split("-");
  return arr1[0] + "-" + arr1[1] + "-" + arr1[2];
}
// 将2023-10-16 21:32:51格式的数据转换成 10月16日21:32格式
export function dateChangeFomat3(dateString) {
  const date = new Date(dateString);
  const options = { month: "long", day: "numeric" };
  const month = date
    .toLocaleString("zh-CN", options)
    .replace("月", "月")
    .replace("日", "日");
  const time = date.toTimeString().slice(0, 5);
  return `${month}${time}`;
}

// 将2024-06-28  19:53:12 转换为 2024年06月28日 格式
export function dateFormat(date) {
  var arr = date.split(" ");
  var arr1 = arr[0].split("-");
  return arr1[0] + "年" + arr1[1] + "月" + arr1[2] + "日";
}

// 2024-12-09-2024-12-15 --->  12.09-12.15
export function formatDateRange(dateRange) {
  const dates = dateRange.split("-"); // 分割字符串为数组
  const startMonthDay = dates[1] + "." + dates[2]; // 提取开始的月日
  const endMonthDay = dates[4] + "." + dates[5]; // 提取结束的月日
  return `${startMonthDay}-${endMonthDay}`; // 拼接结果
}
